import { useQuery } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

export function useListStaff() {
  const api = useOsApi()

  return useQuery({
    queryKey: ['staff'],
    queryFn: async () => {
      const response = await api.get('/staff')
      if (!response.success) throw new Error(response.error.message)
      return response.data.staff
    },
  })
}
